import { ElementRef, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { combineLatest, defer, concat, fromEvent, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VisibilityService {
  public pageVisible$: Observable<boolean>;

  constructor(@Inject(DOCUMENT) document: any) {
    this.pageVisible$ = concat(
      defer(() => of(!document.hidden)),
      fromEvent(document, 'visibilitychange').pipe(map(e => !document.hidden))
    );
  }

  elementVisible(element: ElementRef): Observable<boolean> {
    const el = element.nativeElement;

    const elementVisibleOnPage$ = new Observable(observer => {
      const intersectionObserver = new IntersectionObserver(entries => {
        observer.next(entries);
      });

      intersectionObserver.observe(el);

      return () => {
        intersectionObserver.disconnect();
      };
    }).pipe(
      map((entries: IntersectionObserverEntry[]) => entries[0].isIntersecting),
      distinctUntilChanged()
    );

    const elementVisible$ = combineLatest([this.pageVisible$, elementVisibleOnPage$]).pipe(
      map(([pageVisible, elementVisibleOnPage]) => pageVisible && elementVisibleOnPage),
      distinctUntilChanged()
    );

    return elementVisible$;
  }
}
